import { useEffect } from 'react'
import { updatePageTitle } from '../../redux/active_page/actions'
import { useDispatch } from 'react-redux'
import { Dispatch } from 'redux'
const ContactPage = () => {

	const dispatch: Dispatch = useDispatch()
	useEffect(() => {
		dispatch(updatePageTitle("Contact ME"));
	}, [])
	return (
		<div className="center c-center">
			<div className="contact">
				<div className="contact-details">
					<div className="c-heading">
						<h1 className="no-select">contact</h1>
					</div>
					<div className="c-para">
						<p>
							Contact me for any kind of website development using Core Front-End or Wordpress. If you want to update your website, modify its content or add animations, I'll do it for you.
							You can also contact me for paid Project / Assignments of (Front-End / Angular / Java / Spring Boot)
						</p>
					</div>
					<div className="my-details">
						<div className="my-details-box">
							<h4 className="my-details-h no-select">address</h4>
							<p className="my-details-a">Civil lines, Gujrat, Pakistan.</p>
						</div>
						<div className="my-details-box">
							<h4 className="my-details-h no-select">Phone</h4>
							<a className="my-details-a">+92 316 7640745</a>
						</div>
						<div className="my-details-box">
							<h4 className="my-details-h no-select">e-mail</h4>
							<a className="my-details-a">codejavawithsaqib@gmail.com</a>
						</div>
					</div>
				</div>
				<div className="contact-form">
					<div className="c-heading">
						<h1 className="no-select">contact FORM</h1>
					</div>
					<form action="../index.html" autoComplete="off">
						<div className="input-container">
							<input type="text" name="name" className="input" />
							<label htmlFor="">Name</label>
							<span>Name</span>
						</div>
						<div className="input-container">
							<input type="email" name="email" className="input" />
							<label htmlFor="">Email</label>
							<span>Email</span>
						</div>
						<div className="input-container">
							<input type="tel" name="phone" className="input" />
							<label htmlFor="">Phone</label>
							<span>Phone</span>
						</div>
						<div className="input-container">
							<input type="text" name="message" className="input" />
							<label htmlFor="">Message</label>
							<span>Message</span>
						</div>
						<div className="btn-container">
							<input type="submit" value="Send" className="btn" />
						</div>
					</form>
				</div>
			</div>
		</div>
	)
}

export default ContactPage